import window from 'window-or-global';
import { getOverride } from '@confluence/meta';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { domBind } from '../../lib/dom-event';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

// A proprietary mechanism for moving breadcrumbs to/from preview mode.
function init() {
	let $title;

	// Move breadcrumbs into editor precursor
	function moveIntoEditor() {
		const bc = $('#breadcrumbs');
		bc.detach();
		if (!bc.find('.edited-page-title').length && $title.length) {
			bc.append($title);
		}
		$('#editor-precursor .cell').prepend(bc);
	}

	function moveIntoTitle() {
		const bc = $('#breadcrumbs').detach();
		$title.detach();
		$('#breadcrumb-section').append(bc);
	}

	if (getOverride('content-type') !== 'comment') {
		const $quickEditBreadcrumbs = $('#quickedit-breadcrumbs');
		if ($quickEditBreadcrumbs.length > 0) {
			$('#breadcrumbs').detach();
			$quickEditBreadcrumbs.attr('id', 'breadcrumbs');
			$('#breadcrumb-section').append($quickEditBreadcrumbs);
		}

		// Remove breadcrumb title added by velocity for later use
		$title = $('.edited-page-title').parent().detach();

		moveIntoEditor();

		// Move breadcrumbs between preview / edit
		domBind(window.document, 'mode-changed', (e, mode) => {
			if (mode === 'preview') {
				moveIntoTitle();
			} else if (mode === 'richtext') {
				moveIntoEditor();
			}
		});
	}
}

export function breadCrumbs() {
	/*
        this feature assumes this DOM structure exists and is created in theme-atlassian.js

        <div id="editor-precursor">
            <div class="cell">
                <ol id="breadcrumbs"><ol>
                ....
            </div>
            ....
        </div>
    */
	bind('init.rte', init);
}

export function breadCrumbsWRM() {
	return ['wr!confluence.web.resources:breadcrumbs'];
}
